import { useMatchMedia } from '@enuygun/design-system'
import { down } from 'styled-breakpoints'
import { useBreakpoint } from 'styled-breakpoints/react-styled'

import { useUserDevice } from '../context/UserAgent'

const useIsMobile = () => {
  const ua = useUserDevice()
  const breakpointsSm = useBreakpoint(down('sm'))
  const breakpointsMd = useBreakpoint(down('md'))

  const { sm, xs } = useMatchMedia()
  return ua?.isMobile || xs || sm || breakpointsSm || breakpointsMd
}

export { useIsMobile }
